<st-grid-search
    #searchInput
    [isSearchActive]="isSearchActive()"
    (searchTermChanged)="onSearchTermChanged($event)"
    (executeSearch)="executeSearch()"
    (navigate)="navigate($event)" />

<wj-flex-grid
    #flexGrid
    selectionMode="ListBox"
    headersVisibility="All"
    [allowAddNew]="true"
    [alternatingRowStep]="0"
    [allowSorting]="false"
    [frozenColumns]="6"
    [quickAutoSize]="true"
    [autoGenerateColumns]="false"
    [autoScroll]="true"
    [deferResizing]="true"
    [autoClipboard]="false"
    (loadedRows)="onLoadedRows(flexGrid)"
    (loadingRows)="onLoadingRows(flexGrid)"
    (resizedColumn)="onResizedColumn(flexGrid, $event)"
    (initialized)="initializedGrid(flexGrid)">
    <ng-template
        let-cell="cell"
        wjFlexGridCellTemplate
        cellType="RowHeader"
        [autoSizeRows]="false">
        @if (cell.row?.dataItem?.Guid) {
            <div
                class="drag-column"
                [attr.draggable]="!isRundownArchived()"
                [class.drag-column-disabled]="isRundownArchived()"
                [class.drag-column-selected]="cell.row?.isSelected">
                <mat-icon
                    fontSet="material-symbols-outlined"
                    class="drag-column__icon"
                    [attr.draggable]="!isRundownArchived()">
                    drag_indicator
                </mat-icon>
            </div>
        }
    </ng-template>
    <wj-flex-grid-column
        name="delete-column"
        cssClass="delete-column"
        [allowResizing]="false"
        [allowDragging]="false"
        [width]="35">
        <ng-template
            let-cell="cell"
            wjFlexGridCellTemplate
            cellType="Cell"
            [autoSizeRows]="false">
            <div class="delete-column__icon">
                <mat-icon
                    fontSet="material-symbols-outlined"
                    class="delete-icon"
                    (click)="deleteBasicContent(cell)">
                    delete
                </mat-icon>
            </div>
        </ng-template>
    </wj-flex-grid-column>
    @for (column of gridLayout()?.columns; track column) {
        @let minWidth = column.autoSizeWidth ? 100 : column.width;
        @switch (column.name) {
            @case (PSTFieldNames.MOSStatus) {
                <wj-flex-grid-column
                    [binding]="column.name"
                    [header]="column.displayName"
                    [isReadOnly]="true"
                    [multiLine]="true"
                    [isContentHtml]="true"
                    [minWidth]="minWidth"
                    [cellTemplate]="mosStatusCellTemplate"
                    [width]="column.width" />
            }
            @case (PSTFieldNames.MOSChannels) {
                <wj-flex-grid-column
                    [binding]="column.name"
                    [header]="column.displayName"
                    [isReadOnly]="true"
                    [multiLine]="true"
                    [minWidth]="minWidth"
                    [quickAutoSize]="column.autoSizeWidth"
                    [width]="column.width">
                    <ng-template
                        let-cell="cell"
                        wjFlexGridCellTemplate
                        cellType="Cell">
                        <div class="mos-channels">
                            @if (cell.item.MOSChannels | isArray) {
                                @for (channel of cell.item.MOSChannels; track channel) {
                                    <span>{{ channel }}</span>
                                }
                            } @else {
                                <span>{{ cell.item.MOSChannels }}</span>
                            }
                        </div>
                    </ng-template>
                </wj-flex-grid-column>
            }
            @case (PSTFieldNames.MOSAbstracts) {
                <wj-flex-grid-column
                    [binding]="column.name"
                    [header]="column.displayName"
                    [isReadOnly]="true"
                    [multiLine]="true"
                    [minWidth]="minWidth"
                    [isContentHtml]="true"
                    [quickAutoSize]="column.autoSizeWidth"
                    [width]="column.width" />
            }
            @case (PSTFieldNames.MOSIDs) {
                <wj-flex-grid-column
                    [binding]="column.name"
                    [header]="column.displayName"
                    [isReadOnly]="true"
                    [multiLine]="true"
                    [isContentHtml]="true"
                    [minWidth]="minWidth"
                    [quickAutoSize]="column.autoSizeWidth"
                    [width]="column.width" />
            }
            @case (PSTFieldNames.MOSSlugs) {
                <wj-flex-grid-column
                    [binding]="column.name"
                    [header]="column.displayName"
                    [isReadOnly]="true"
                    [multiLine]="true"
                    [isContentHtml]="true"
                    [minWidth]="minWidth"
                    [quickAutoSize]="column.autoSizeWidth"
                    [width]="column.width" />
            }
            @case (PSTFieldNames.MOSObjSlugs) {
                <wj-flex-grid-column
                    [binding]="column.name"
                    [header]="column.displayName"
                    [isReadOnly]="true"
                    [multiLine]="true"
                    [isContentHtml]="true"
                    [minWidth]="minWidth"
                    [quickAutoSize]="column.autoSizeWidth"
                    [width]="column.width" />
            }
            @case (PSTFieldNames.MOSItemDurations) {
                <wj-flex-grid-column
                    [binding]="column.name"
                    [header]="column.displayName"
                    [isReadOnly]="true"
                    [multiLine]="true"
                    [isContentHtml]="true"
                    [minWidth]="minWidth"
                    [quickAutoSize]="column.autoSizeWidth"
                    [width]="column.width" />
            }
            @case (PSTFieldNames.ObjectAutoCreate) {
                <wj-flex-grid-column
                    [cssClass]="column.isReadOnly ? '' : 'object-auto-create-column'"
                    [binding]="column.name"
                    [header]="column.displayName"
                    [isReadOnly]="column.isReadOnly"
                    [minWidth]="minWidth"
                    [isContentHtml]="true"
                    [editor]="objectAutoCreateEditor"
                    [width]="column.width"
                    [cellTemplate]="objectAutoCreateCellTemplate" />

                <wj-combo-box
                    #objectAutoCreateEditor
                    [itemFormatter]="objectAutoCreateItemFormatter"
                    [itemsSource]="autoCreateMosDeviceItemsList" />
            }
            @case (PSTFieldNames.MOSTimes) {
                <wj-flex-grid-column
                    [binding]="column.name"
                    [header]="column.displayName"
                    [isReadOnly]="true"
                    [multiLine]="true"
                    [isContentHtml]="true"
                    [minWidth]="minWidth"
                    [quickAutoSize]="column.autoSizeWidth"
                    [width]="column.width" />
            }
            @case (PSTFieldNames.ObjectPlaceholderCreate) {
                <wj-flex-grid-column
                    [binding]="column.name"
                    [header]="column.displayName"
                    [isContentHtml]="true"
                    [isReadOnly]="true"
                    [minWidth]="minWidth"
                    [width]="column.width">
                    <ng-template
                        let-cell="cell"
                        wjFlexGridCellTemplate
                        cellType="Cell">
                        <div
                            #btnClickNone
                            class="object-placeholder-create-value"
                            (click)="objectPlaceHolderCreatePopupCreate($event, btnClickNone, cell)">
                            <span [innerHTML]="cell.item?.ObjectPlaceholderCreate"></span>
                        </div>
                    </ng-template>
                </wj-flex-grid-column>
            }
            @case (PSTFieldNames.Slug) {
                <wj-flex-grid-column
                    [binding]="column.name"
                    [header]="column.displayName"
                    [isReadOnly]="column.isReadOnly"
                    [minWidth]="minWidth"
                    [width]="column.width">
                    @if (storiesLockStatus()) {
                        <ng-template
                            let-cell="cell"
                            wjFlexGridCellTemplate
                            cellType="ColumnHeader">
                            <mat-icon
                                small
                                class="st-ro-grid__lock-icon">
                                lock
                            </mat-icon>
                            {{ column.displayName }}
                        </ng-template>
                    }
                </wj-flex-grid-column>
            }
            @case (PSTFieldNames.Segment) {
                <wj-flex-grid-column
                    name="segment"
                    cssClass="segment-column"
                    [binding]="column.name"
                    [header]="column.displayName"
                    [isContentHtml]="true"
                    [isReadOnly]="column.isReadOnly"
                    [minWidth]="minWidth"
                    [width]="column.width">
                    <ng-template
                        let-cell="cell"
                        wjFlexGridCellTemplate
                        cellType="Cell"
                        [autoSizeRows]="false">
                        <span
                            class="segment-column__value"
                            [innerHTML]="cell.item?.Segment"></span>
                        <div class="segment-column__icon">
                            <mat-icon
                                fontSet="material-symbols-outlined"
                                class="segment-column__edit-icon"
                                (click)="openStory(cell)">
                                edit
                            </mat-icon>
                        </div>
                    </ng-template>
                </wj-flex-grid-column>
            }
            <!-- @TODO Fix ModBy Validation - i.e. should be StaffIDList, not Text -->
            @case (PSTFieldNames.ModBy) {
                <wj-flex-grid-column
                    [cssClass]="column.isReadOnly ? '' : 'staff-id-list-column'"
                    [binding]="column.name"
                    [header]="column.displayName"
                    [isReadOnly]="column.isReadOnly"
                    [isContentHtml]="true"
                    [minWidth]="minWidth"
                    [editor]="staffIdListEditor"
                    [width]="column.width"
                    [cellTemplate]="staffIdListCellTemplate" />
                <wj-multi-select
                    #staffIdListEditor
                    [itemFormatter]="staffIdListItemFormatter"
                    [headerFormatter]="staffIdListHeaderFormatter"
                    [showFilterInput]="true"
                    [checkOnFilter]="false"
                    [itemsSource]="column.columnList" />
            }
            @default {
                @switch (column.validation) {
                    @case (fieldDefValidations.COMBOBOX) {
                        <wj-flex-grid-column
                            [cssClass]="column.isReadOnly ? '' : 'combo-box-column'"
                            [binding]="column.name"
                            [header]="column.displayName"
                            [isReadOnly]="column.isReadOnly"
                            [minWidth]="minWidth"
                            [isContentHtml]="true"
                            [quickAutoSize]="column.autoSizeWidth"
                            [width]="column.width"
                            [editor]="comboboxEditor"
                            [cellTemplate]="comboBoxCellTemplate" />
                        <wj-combo-box
                            #comboboxEditor
                            selectedValuePath="id"
                            displayMemberPath="title"
                            [itemsSource]="column.columnList" />
                    }
                    @case (fieldDefValidations.CHECKLIST) {
                        <wj-flex-grid-column
                            [cssClass]="column.isReadOnly ? '' : 'checklist-column'"
                            [binding]="column.name"
                            [header]="column.displayName"
                            [isContentHtml]="true"
                            [isReadOnly]="column.isReadOnly"
                            [minWidth]="minWidth"
                            [quickAutoSize]="column.autoSizeWidth"
                            [editor]="checkListEditor"
                            [width]="column.width"
                            [cellTemplate]="checkListCellTemplate" />
                        <wj-multi-select
                            #checkListEditor
                            selectedValuePath="id"
                            displayMemberPath="title"
                            [itemsSource]="column.columnList" />
                    }
                    <!-- @case (fieldDefValidations.CHECKLISTEDIT) {
                        <wj-flex-grid-column
                            cssClass="checklist-column"
                            [binding]="column.name"
                            [header]="column.displayName"
                            [isReadOnly]="column.isReadOnly"
                            [minWidth]="minWidth"
                            [quickAutoSize]="column.autoSizeWidth"
                            [editor]="checkListEditEditor"
                            [dataMap]="column.columnListDataMap"
                            [width]="column.width" />
                        <wj-auto-complete
                            #checkListEditEditor
                            selectedValuePath="id"
                            displayMemberPath="title"
                            [itemsSource]="column.columnList" />
                    } -->
                    @case (fieldDefValidations.STAFFIDLIST) {
                        <wj-flex-grid-column
                            [cssClass]="column.isReadOnly ? '' : 'staff-id-list-column'"
                            [binding]="column.name"
                            [header]="column.displayName"
                            [isReadOnly]="column.isReadOnly"
                            [isContentHtml]="true"
                            [minWidth]="minWidth"
                            [editor]="staffIdListEditor"
                            [width]="column.width"
                            [cellTemplate]="staffIdListCellTemplate" />
                        <wj-multi-select
                            #staffIdListEditor
                            [itemFormatter]="staffIdListItemFormatter"
                            [headerFormatter]="staffIdListHeaderFormatter"
                            [showFilterInput]="true"
                            [checkOnFilter]="false"
                            [itemsSource]="column.columnList" />
                    }
                    @case (fieldDefValidations.DURATION) {
                        <wj-flex-grid-column
                            cssClass="duration-column"
                            align="right"
                            dataType="Object"
                            [binding]="column.name"
                            [header]="column.displayName"
                            [isContentHtml]="true"
                            [isReadOnly]="column.isReadOnly"
                            [minWidth]="minWidth"
                            [isRequired]="false"
                            [cellTemplate]="durationCellTemplate"
                            [width]="column.width" />
                    }
                    @case (fieldDefValidations.TIME) {
                        <wj-flex-grid-column
                            cssClass="time-column"
                            align="right"
                            dataType="Object"
                            [binding]="column.name"
                            [header]="column.displayName"
                            [isReadOnly]="column.isReadOnly"
                            [minWidth]="minWidth"
                            [cellTemplate]="timeCellTemplate"
                            [width]="column.width" />
                    }
                    @case (fieldDefValidations.DATE) {
                        <wj-flex-grid-column
                            cssClass="date-column"
                            align="right"
                            dataType="Object"
                            [binding]="column.name"
                            [header]="column.displayName"
                            [isContentHtml]="true"
                            [isReadOnly]="column.isReadOnly"
                            [minWidth]="minWidth"
                            [cellTemplate]="dateCellTemplate"
                            [width]="column.width" />
                    }
                    @case (fieldDefValidations.MOSDATETIME) {
                        <wj-flex-grid-column
                            cssClass="mos-datetime-column"
                            align="right"
                            dataType="Object"
                            [binding]="column.name"
                            [header]="column.displayName"
                            [isReadOnly]="column.isReadOnly"
                            [isContentHtml]="true"
                            [minWidth]="minWidth"
                            [cellTemplate]="timeCellTemplate"
                            [width]="column.width" />
                    }
                    @case (fieldDefValidations.CHECKBOX) {
                        <wj-flex-grid-column
                            cssClass="checkbox-column"
                            align="right"
                            [dataType]="3"
                            [binding]="column.name"
                            [header]="column.displayName"
                            [isReadOnly]="column.isReadOnly"
                            [minWidth]="minWidth"
                            [width]="column.width" />
                    }
                    @case (fieldDefValidations.SPECIAL) {
                        <wj-flex-grid-column
                            cssClass="special-column"
                            [dataType]="3"
                            [binding]="column.name"
                            [header]="column.displayName"
                            [isContentHtml]="true"
                            [isReadOnly]="true"
                            [minWidth]="minWidth"
                            [width]="column.width" />
                    }
                    @default {
                        <wj-flex-grid-column
                            cssClass="default-column"
                            [binding]="column.name"
                            [header]="column.displayName"
                            [isReadOnly]="column.isReadOnly"
                            [isContentHtml]="true"
                            [wordWrap]="column.wordWrap"
                            [multiLine]="column.wordWrap"
                            [minWidth]="minWidth"
                            [width]="column.width" />
                    }
                }
            }
        }
    }
</wj-flex-grid>
<st-ro-grid-timing-bar
    [record]="record()"
    [layout]="gridLayout()"
    [selectedRows]="selectedRows()" />

<wj-popup
    #objectPlaceHolderCreatePopup
    class="popover"
    hideTrigger="None">
    <div class="object-placeholder-create-popup">
        <div class="wj-labeled-input">
            <wj-combo-box
                #mosDevicesCb
                selectedValuePath="id"
                displayMemberPath="title"
                [itemsSource]="autoCreateMosDeviceItems()"
                [(selectedValue)]="mosDevicesCbValue"
                (selectedIndexChanged)="onMosTypeChanged(mosDevicesCb.selectedIndex, mosTypesCb)" />
            <label for="mosDevicesCb">MOS</label>
        </div>
        <div class="wj-labeled-input">
            <wj-combo-box
                #mosGroupsCb
                [itemsSource]="objectPlaceholderCreateGroupsItemSource()"
                [(selectedValue)]="mosGroupsCbValue"
                [(text)]="mosGroupsCbValue" />
            <label for="mosGroupsCb">Group</label>
        </div>
        <div class="wj-labeled-input">
            <wj-combo-box
                #mosTypesCb
                selectedValuePath="id"
                displayMemberPath="title"
                [itemsSource]="mosTypes()"
                [(selectedValue)]="mosTypesCbValue" />
            <label for="mosTypesCb">Type</label>
        </div>
        <div class="wj-labeled-input">
            <wj-combo-box
                #mosSlugCb
                [(text)]="mosSlugCbValue" />
            <label for="mosSlugCb">Slug</label>
        </div>
        <button
            class="btn btn-danger wj-hide"
            (click)="cancelPlaceholderCreate()">
            Cancel
        </button>
        <button
            class="btn btn-primary wj-hide-ok"
            (click)="createPlaceholder()">
            Save
        </button>
    </div>
</wj-popup>
